import  './loader.css'

interface LoaderProps {
  style?: React.CSSProperties;
}

const Loader: React.FC<LoaderProps> = ({ style }) => {
  return (
      <div className='loader' style={style}>
          <div className='load'>
              <div className='wrapper'>
                  <div className='spinner'></div>
              </div>
            </div>
          </div>
  )
}

export default Loader